import { Edit, SimpleForm, TextInput, required, minLength, maxLength } from 'react-admin';

const validateName = [required(), minLength(2), maxLength(100)];

export const GroupEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled fullWidth />
      <TextInput source="name" validate={validateName} fullWidth />
    </SimpleForm>
  </Edit>
);
